import { absoluteFromHost } from '@/shared/lib/utils/absolute-url';

export const SCHEMA_ORGANIZATION_NAME = 'Промышленно-энергетический форум TNF';
export const SCHEMA_PLACE_NAME = 'Тюменский Технопарк';
export const SCHEMA_FORUM_EVENT_NAME = 'Промышленно-энергетический форум TNF 2026';

export const SCHEMA_CONTACT_FALLBACK = {
    telephone: '+7-800-550-55-44',
    email: 'welcome@oilgasforum.ru',
    streetAddress: 'ул. Республики, 142',
    addressLocality: 'Тюмень',
    postalCode: '625026',
    addressCountry: 'RU',
} as const;

export const SCHEMA_EXPO_FALLBACK_NAME = 'Выставка форума TNF 2026';
export const SCHEMA_EXPO_FALLBACK_DESCRIPTION =
    'Экспозиционная площадка Промышленно-энергетического форума TNF: стенды компаний ТЭК, демонстрация оборудования и технологий, демозоны и уличная экспозиция.';

export const SCHEMA_EVENT_STATUS = 'https://schema.org/EventScheduled';
export const SCHEMA_EVENT_ATTENDANCE = 'https://schema.org/OfflineEventAttendanceMode';
export const SCHEMA_OFFER_AVAILABILITY = 'https://schema.org/InStock';

export function getSchemaOrigin(): string {
    return (process.env.NEXT_PUBLIC_HOST || '').trim().replace(/\/$/, '');
}

export function getSchemaSiteUrl(): string {
    const origin = getSchemaOrigin();
    return origin ? `${origin}/` : '/';
}

export function schemaAbsoluteUrl(path: string): string {
    return absoluteFromHost(getSchemaOrigin(), path) || path;
}

export function schemaPageUrl(path: string): string {
    const norm = path.startsWith('/') ? path : `/${path}`;
    const withSlash = norm.endsWith('/') ? norm : `${norm}/`;
    return schemaAbsoluteUrl(withSlash);
}

export function getSchemaIds() {
    const origin = getSchemaOrigin();
    return {
        organization: `${origin}/#organization`,
        website: `${origin}/#website`,
        forum: `${origin}/#forum`,
        tnfForum: `${origin}/participation/participants/#tnf-forum`,
        tnfExpo: `${origin}/participation/visitors/#tnf-expo`,
        exhibition: `${origin}/expo/#exhibition`,
    };
}
